import { render, staticRenderFns } from "./MessagingChats.vue?vue&type=template&id=09548dd8"
import script from "./MessagingChats.vue?vue&type=script&lang=js"
export * from "./MessagingChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports